type RuntimeEnv = Record<string, string | undefined>;

const browserEnv = typeof window !== 'undefined'
  ? window.process?.env as RuntimeEnv | undefined
  : undefined;
const buildEnv = import.meta.env as RuntimeEnv;

function keepDefinedValues(env: RuntimeEnv | undefined): RuntimeEnv {
  if (!env) {
    return {};
  }

  return Object.fromEntries(
    Object.entries(env).filter(([, value]) => value !== undefined && value !== '')
  );
}

export const runtimeEnv: RuntimeEnv = {
  ...keepDefinedValues(buildEnv),
  ...keepDefinedValues(browserEnv),
};
